import React from 'react';
import { ApButtonLink } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostLabel,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../../EnvironmentSetup/EnvironmentSetup.styles';
import CodeSnippet from '../../../../components/CodeSnippet';

interface IProps {
  dataStorageName: string;
  dataStorageUrl: string;
}

export const StorageSection = ({ dataStorageName, dataStorageUrl }: IProps) => {
  return (
    <SectionWrapper animationIndex={3}>
      <Title>Storage</Title>
      <ContentBlock>
        <Description>Azure Data Lake (Gen 2)</Description>
        <RightSection>
          <RightSectionColumn>
            <CostLabel>Storage Name</CostLabel>
            <CodeSnippet>{dataStorageName}</CodeSnippet>
          </RightSectionColumn>

          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={dataStorageUrl}
                rel="noopener noreferrer"
              >
                Azure data lake (gen 2) link
              </ApButtonLink>
            </CostValue>
          </RightSectionColumn>
          <RightSectionColumn />
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
